import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nullCheck'
})
export class NullCheckPipe implements PipeTransform {

    /**
     * Pipe to check null values and replace them with '--'
     *
     * @param value Value to be checked and replaced.
     * @param extraVals Any extra values to checked while conversion.
     * @returns value itself if not null or '--'
     */
    transform(value: any, ...extraVals: any[]): any {
        if (value === null ||
            value === undefined ||
            value === 'NaN' ||
            value === '' || (
                extraVals && extraVals.includes(value)
            )) {
            return '--';
        }

        return value;
    }
}
